/**
 * Actions Redux pour la feature "Prestation avec service" — calcul auto
 * des lignes Maître d'hôtel / Serveur lors de la coche "avec service".
 *
 * Doc fonctionnelle : lemoulinapi/docs/pro/prestation-service.md
 */
export const FETCH_SERVICE_PRODUCTS = "FETCH_SERVICE_PRODUCTS";
export const FETCH_SERVICE_PRODUCTS_COMPLETED = "FETCH_SERVICE_PRODUCTS_COMPLETED";
export const FETCH_SERVICE_PRODUCTS_FAILED = "FETCH_SERVICE_PRODUCTS_FAILED";

/**
 * Récupère les Pro\Offer\Product taggés `prestation-service` côté API.
 * Endpoint : GET /api/pro/offer/products/service-defaults.json
 * Retour : array de { id, name, price, pricePerPerson, categoryName, role }
 *          (role: "master" | "waiter" | "other")
 */
export const fetchServiceProducts = () => ({
  type: FETCH_SERVICE_PRODUCTS,
  meta: {
    async: true,
    blocking: false,
    path: "/api/pro/offer/products/service-defaults.json",
    method: "GET",
  },
});
